module.exports = __webpack_public_path__ + "img/tips.ab63ba5d.png";